import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { SpinnerService } from '../services/spinner/spinner.service';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

@Injectable()
export class SpinnerInterceptorService implements HttpInterceptor {

  //#region variables
  private requests: HttpRequest<any>[] = [];
  //#endregion

  //#region Constructor
  constructor(private loaderService: SpinnerService) { }
  //#endregion

  //#region functions
  /**
   * Drop a finished request and reflect whether any are still in flight.
   */
  removeRequest(req: HttpRequest<any>) {
    const i = this.requests.indexOf(req);
    if (i >= 0) {
      this.requests.splice(i, 1);
    }
    this.loaderService.isLoading.next(this.requests.length > 0);
  }

  /**
   * intercept
   * @param request
   * @param next
   */
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // ✅ Check if request has custom header to skip loader
    const skipLoader = request.headers.has('X-Skip-Loader');

    // These requests never drive the loader — strip the marker and pass through.
    if (skipLoader) {
      request = request.clone({
        headers: request.headers.delete('X-Skip-Loader')
      });
      return next.handle(request);
    }

    // Track this request and show the loader.
    this.requests.push(request);
    this.loaderService.show();

    // `finalize` fires on success, error AND cancellation (unsubscribe), so a
    // failed or aborted request can never leave the loader stuck on screen. The
    // previous implementation only hid on HttpResponse and leaked on any other
    // outcome; `requests`/`removeRequest` were declared but never used, so
    // concurrent requests weren't counted either.
    return next.handle(request).pipe(
      finalize(() => this.removeRequest(request))
    );
  }
  //#endregion
}
